import {env} from "next-runtime-env";

export async function loadRecaptcha() {
  return new Promise((resolve, reject) => {
    const siteKey = env('NEXT_PUBLIC_RECAPTCHA_SITE_KEY');
    if (!siteKey) {
      reject(new Error('Recaptcha site key is not defined'));
      return;
    }
    grecaptcha.ready(() => {
      grecaptcha.execute(siteKey, { action: 'submit' })
        .then((token) => {
          resolve(token);
        })
    });
  });
}

export async function verifyRecaptchaToken(token: string): Promise<{ success: boolean, message?: string }> {
  const secret = env('RECAPTCHA_SECRET_KEY');
  if (!secret) {
    return { success: false, message: 'Recaptcha secret key is not defined' };
  }

  try {
    const response = await fetch('https://www.google.com/recaptcha/api/siteverify', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded', // should not be JSON
      },
      body: new URLSearchParams({
        secret,
        response: token,
      }),
    });

    const data = await response.json();

    if (!data.success) {
      return {
        success: false,
        message: `Recaptcha failed: ${data['error-codes']?.join(', ') || 'Unknown error'}`,
      };
    }

    return { success: true };

  } catch (error: unknown) {
    return {
      success: false,
      message: `Recaptcha verification error: ${error instanceof Error ? error.message : String(error)}`,
    };
  }
}
